import React from 'react';
import { MessageSquare } from 'lucide-react';

const SendMessage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 hero-pattern relative overflow-hidden">
        <div className="container mx-auto text-center relative z-10">
          <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-lg p-8 rounded-2xl border border-white/10">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              Trimite un Mesaj
            </h1>
            <p className="text-xl text-white/80">
              Suntem aici să te ajutăm. Trimite-ne un mesaj și te vom contacta în curând.
            </p>
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/50 to-primary opacity-90"></div>
      </section>

      {/* Message Form Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto max-w-3xl">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center mb-8">
              <MessageSquare className="h-6 w-6 text-primary mr-3" />
              <h2 className="text-2xl font-bold">Formular de Contact</h2>
            </div>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="name">
                    Nume
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="subject">
                  Subiect
                </label>
                <input
                  type="text"
                  id="subject"
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="message">
                  Mesaj
                </label>
                <textarea
                  id="message"
                  rows={8}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary resize-none"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary-dark transition duration-300"
              >
                Trimite Mesajul
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default SendMessage;